import { render, staticRenderFns } from "./LiveCheckinFeed.vue?vue&type=template&id=54c82047&scoped=true&"
import script from "./LiveCheckinFeed.vue?vue&type=script&lang=js&"
export * from "./LiveCheckinFeed.vue?vue&type=script&lang=js&"
import style0 from "./LiveCheckinFeed.vue?vue&type=style&index=0&id=54c82047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c82047",
  null
  
)

export default component.exports